import classNames from 'classnames';
import React from 'react';

export default function Dropdown({
	id: initialId,
	name,
	errorMessage = false,
	isRequired,
	label,
	options: initialOptions = [],
	allowBlank = false,
	disabled,

	// uncontrolled
	defaultValue,

	// controlled
	value,
	onChange,
	labelFn = lbl => lbl,
	...props
}) {
	const id = initialId || `field--${name}`;

	const hasError =
		(typeof errorMessage === 'boolean' && errorMessage === true) || errorMessage.length > 0;

	const options = initialOptions.map(option => {
		if (typeof option === 'string' || typeof option === 'number') {
			return { label: option, value: option };
		}
		return option;
	});

	const labelToDisplay = isRequired ? label + '*' : label;
	const optionValue = options?.find(option => option.value === value);

	return (
		<div className="ty-b2 Dropdown formElement ValidatedForm-Field">
			<select
				id={id}
				name={name}
				className={classNames('Dropdown-field formElement-field ty-b2', {
					'Dropdown-field--filled': value,
					'formElement-field--invalid': hasError,
				})}
				required={isRequired}
				disabled={disabled}
				defaultValue={defaultValue}
				value={value}
				onChange={onChange}
				{...props}
			>
				{(value === '' || allowBlank) && <option value="" disabled={!allowBlank}></option>}

				{options.map(option => {
					return (
						<option
							key={option.value}
							value={option.value}
							disabled={option.disabled}
							data-filter-option=""
						>
							{option.label}
						</option>
					);
				})}
			</select>

			<div className="Dropdown-labelContainer">
				<label className="formElement-label ty-c4" htmlFor={id}>
					{labelFn(labelToDisplay, optionValue?.label || value || '')}
				</label>
				<span className="mask">{labelToDisplay}</span>
			</div>

			{typeof errorMessage === 'string' && errorMessage.length > 0 && (
				<span className="formElement-message" role="alert">
					{errorMessage}
				</span>
			)}
		</div>
	);
}
